import { Component, OnInit, Input } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { ThisPlatform } from "../../../_services/platform.service";

@Component({
  selector: "app-modal-input",
  templateUrl: "./modal-input.component.html",
  styleUrls: [
    "./modal-input.component.scss",
    "./../../../_styles/ion-grid-box.scss",
  ],
})
export class ModalInputComponent implements OnInit {
  mobile: boolean = false;

  @Input()
  modalTitle: string;

  @Input()
  inputValue: any;

  @Input()
  inputType: string;

  @Input()
  inputTitle: string;

  @Input()
  inputPlaceholder: string;

  @Input()
  saveTitle: string;

  constructor(
    public modalController: ModalController,
    public platform: Platform,
    public p: ThisPlatform
  ) {
    this.mobile = p.isMobile;
  }

  ngOnInit() {}

  save() {
    this.modalController.dismiss({
      save: true,
      inputValue: this.inputValue,
    });
  }

  close() {
    this.modalController.dismiss();
  }
}
